var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"resp_table"},[_c('div',{staticClass:"header_devices"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.translate('esim_profile.section.esim_history')))])]),_c('TextTable',{attrs:{"all_data":_vm.all_data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }